var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeDotIcon16X4 = function SvgThreeDotIcon16X4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 4,
    viewBox: "0 0 15.854 3.171"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108673",
    d: "M9.513 1.585A1.585 1.585 0 1 1 7.928 0a1.585 1.585 0 0 1 1.585 1.585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108674",
    d: "M15.854 1.585A1.585 1.585 0 1 1 14.268 0a1.585 1.585 0 0 1 1.586 1.585"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108675",
    d: "M3.171 1.585A1.585 1.585 0 1 1 1.586 0a1.585 1.585 0 0 1 1.585 1.585"
  })));
};
export default SvgThreeDotIcon16X4;